<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Tools and Equipment</h1>
<p class="CH-INTRO1">To make a batch of whoopie pies, you don’t need much more than you’ll find in any domestic kitchen, but if you are planning on trying your hand at decorating, here is a list of the key tools and equipment you might find helpful:</p>
<p class="ML-NL1-1st">1. Whoopie pie tin – very useful, but greased baking trays can be used instead</p>
<p class="ML-NL1">2. Wire rack – for placing whoopies on to cool</p>
<p class="ML-NL1">3. Small ice cream scoop – for measuring batter for perfect-sized whoopies every time</p>
<p class="ML-NL1">4. Non-stick rolling pin – for rolling out sugarpaste and petal paste</p>
<p class="ML-NL1">5. Paintbrushes – a variety of different sizes are useful for painting, moistening and sticking</p>
<p class="ML-NL1">6. Edible glue – for sticking small pieces of icing together</p>
<p class="ML-NL1">7. Piping (pastry) bags – small for piping royal icing and large for filling whoopies</p>
<p class="ML-NL1">8. Cutters – a variety of cutters are useful for different projects</p>
<p class="ML-NL1">9. Drying mat – a great place to dry small sugarpaste pieces</p>
<p class="ML-NL1">10. Piping tubes (tips) – for filling, piping and decoration (also known as nozzles)</p>
<p class="ML-NL1">11. Palette knife – for lifting delicate sugarpaste pieces</p>
<p class="ML-NL1">12. Paste food colours, edible dusts and edible glitters – for colouring, painting and adding sparkle</p>
<p class="ML-NL1">13. Craft knife – for accurate detailed cutting</p>
<p class="ML-NL1">14. Cocktail sticks (toothpicks) – great for adding tiny amounts of colour and for frilling</p>
<p class="ML-NL1">15. Measuring spoons – for measuring ingredients quickly and accurately</p>
<p class="ML-NL1-last">16. Sugar shaker – for dusting your surface with icing (confectioners’) sugar to prevent sticking</p>
<p class="Image"><img alt="" src="images/tools_fmt.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c02.vue?596ec208